import React from 'react';
import { useLocation, Navigate } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import SuccessView from '../components/availability/SuccessView';
import { formatTime, formatDate, getTodayDateString } from '../utils/appointmentUtils';

/**
 * Page to display appointment confirmation after successful payment
 */
const AppointmentConfirmationPage = () => {
  const location = useLocation();
  
  // Get data from location state
  const { formData, practice, selectedSlot, nextAvailableDates } = location.state || {};
  
  // If no data was passed, redirect to home
  if (!formData || !practice || !selectedSlot) {
    return <Navigate to="/" />;
  }
  
  // Format date for display
  const formatDateFull = (dateString) => {
    const [year, month, day] = dateString.split('-').map(Number);
    const date = new Date(year, month - 1, day);
    
    return date.toLocaleDateString('en-GB', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };
  
  // Handle return to home
  const handleReturnHome = () => {
    // Using window.location.href instead of navigate to ensure a fresh page load
    window.location.href = '/';
  };
  
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-grow py-12 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <SuccessView 
              formData={formData}
              practice={practice}
              selectedSlot={selectedSlot}
              nextAvailableDates={nextAvailableDates}
              formatDateFull={formatDateFull}
              formatTime={formatTime}
              getTodayDateString={getTodayDateString}
              onReturnHome={handleReturnHome}
            />
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default AppointmentConfirmationPage;
